import type {FC} from 'react';

import styled from 'styled-components';

import type {WithDomStyleProp} from '../../../utils/utility-types';
import type {Props, StyledProps} from './types';

import {useController} from './controller';
import {web} from './styles';

const StyledButton = styled.button<StyledProps>`
  ${web}
`;

export const ButtonV2: FC<WithDomStyleProp<Props>> = ({
  accentColor,
  children,
  disabled,
  iconLeft,
  iconRight,
  isLoading,
  onClick,
  scheme = 'primary',
  size = 'me',
  testID,
  variant = 'primary',
  ...rest
}) => {
  const {clickHandler, isDisabled, isSingleIcon, renderContent} = useController(
    {
      accentColor,
      children,
      disabled,
      iconLeft,
      iconRight,
      isLoading,
      onClick,
      scheme,
      size,
      variant,
    } as Required<Props>,
  );

  return (
    <StyledButton
      {...rest}
      accentColor={accentColor}
      data-test-id={testID}
      disabled={isDisabled}
      iconLeft={iconLeft}
      iconRight={iconRight}
      isSingleIcon={isSingleIcon}
      onClick={clickHandler}
      scheme={scheme}
      size={size}
      type="button"
      variant={variant}
    >
      {renderContent()}
    </StyledButton>
  );
};
